<template>
  <div class="detail-container">
    <div class="detail-container__head base-height__30"></div>
    <div class="detail-content">
      <el-tabs v-model="activeName" class="detail-tabs">
        <el-tab-pane :label="$t('computingCluster.instanceList')" name="resource">
          <resource v-if="activeName === 'resource'" @createImageInfo="createImageInfo" />
        </el-tab-pane>
        <el-tab-pane :label="$t('computingCluster.taskManagement.title')" name="taskManage">
          <task-management v-if="activeName === 'taskManage'" />
        </el-tab-pane>
        <el-tab-pane :label="$t('computingCluster.clusterEnvName')" name="clusterEnv">
          <clusterEnv v-if="activeName === 'clusterEnv'" />
        </el-tab-pane>
        <!--<el-tab-pane :label="$t('computingCluster.taskManagement')" name="task">-->
        <!--  <task v-if="activeName==='task'"/>-->
        <!--</el-tab-pane>-->
        <!--<el-tab-pane :label="$t('computingCluster.resourceStatistics')" name="monitor">-->
        <!--  <monitor v-if="activeName==='monitor'"/>-->
        <!--</el-tab-pane>-->
        <el-tab-pane :label="$t('computingCluster.accountManagement')" name="secretKey">
          <secretKey v-if="activeName === 'secretKey'" />
        </el-tab-pane>
        <el-tab-pane :label="$t('computingCluster.imagesManagement')" name="imagesManagement">
          <imagesManagement v-if="activeName === 'imagesManagement'" :createImageDetail="createImageDetail" />
        </el-tab-pane>
        <!--<el-tab-pane :label="$t('computingCluster.templateManagement.templateManagement')" name="templateManagement">-->
        <!--  <TemplateManagement v-if="activeName === 'templateManagement'" />-->
        <!--</el-tab-pane>-->
        <el-tab-pane :label="$t('computingCluster.logManagement')" name="activity">
          <activity v-if="activeName === 'activity'" />
        </el-tab-pane>
        <el-tab-pane :label="$t('computingCluster.basicConfig')" name="detailsInfo">
          <detailsInfo v-if="activeName === 'detailsInfo'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import resource from './components/resource/IndexView.vue';
// import task from './components/job/index.vue';
import clusterEnv from './components/clusterEnv/IndexView.vue';
import imagesManagement from './components/images/IndexView.vue';
// import monitor from './components/monitor/index.vue';
import secretKey from './components/secretKey/IndexView.vue';
import Activity from './components/activity/IndexView.vue';
import DetailsInfo from './components/detailsInfo/IndexView.vue';
// import TemplateManagement from './components/templateManagement/IndexView.vue';
import TaskManagement from './components/taskManage/IndexView.vue';

export default {
  name: 'name',
  components: {
    TaskManagement,
    Activity,
    resource,
    // task,
    // monitor,
    clusterEnv,
    secretKey,
    DetailsInfo,
    imagesManagement,
    // TemplateManagement,
  },
  data() {
    return {
      activeName: 'resource',
      createImageDetail: {
        region: '',
      },
    };
  },

  created() {
    this.activeName = 'resource';
  },

  methods: {
    // js函数
    createImageInfo(data) {
      this.createImageDetail = data;
      this.activeName = 'imagesManagement';
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-container {
  height: 100%;
  min-width: 1100px;
  //background: #fff;

  .detail-container__head {
    padding-left: 20px;
    background: #fff;
    display: flex;
    align-items: center;
    font-size: 14px;

    ::v-deep .el-icon-back {
      font-size: 24px;
    }
  }

  .detail-content {
    height: calc(100% - 52px);

    .detail-tabs {
      height: 100%;

      ::v-deep .el-tabs__header {
        padding: 0 20px;
        background: #fff;
      }

      ::v-deep .el-tabs__content {
        padding: 0 20px;
        height: calc(100% - 55px);

        .el-tab-pane {
          height: 100%;
        }
      }
    }
  }
}
</style>
